export default {
    voted: false
}